import axiosInstance from '@/lib/axios/config/axiosConfig';
import { useMutation } from '@tanstack/react-query';

interface CreateDashboardPayload {
  dashboardName: string;
}

export const useDashboard = () => {
  const createDashboard = useMutation({
    mutationFn: (payload: CreateDashboardPayload) =>
      axiosInstance.post('/api/create-new-dashboard', payload),
  });

  return {
    createDashboard,
  };
};
